import withCart from '../General/withCart';
import { ProductRow } from './ProductRow';
import ViewSwitcher from "../General/ViewSwitcher";
import ItemCard from '../Product/ProductCard';


class ProductListingGrid extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isCompactView: this.props.isCompactView
        }
    }

    setViewSwitcher(data) {
        this.setState({ isCompactView: data.isCompactView });
    }

    render() {
        var pricesHeader = null;
        if (!this.props.hidePrices) {
            pricesHeader = <div className="col-2 col-lg-2 col-hd">Price</div>;
        }
        var addToCartHeader = null;
        if (this.props.canAddToCart) {
            addToCartHeader = "Qty";
        }

        var extraHeaderClass = "";
        if (this.state.isCompactView) {
            extraHeaderClass += " list-compact";
        }

        var viewSwitch = null;
        if (!this.props.hideViewSwitcher) {
            viewSwitch = <div className="col-12 view-switcher-container">
                             <ViewSwitcher onChange={this.setViewSwitcher.bind(this)} />
                         </div>;
        }

       

        return (
            <div className="abco-section">
                <div className="row">
                    {this.props.productCollection.map((item) => {
                        return <div className="col-lg-3"><ItemCard
                            key={"item-row-" + item.stockcode}
                            item={item}
                            canAddToCart={this.props.canAddToCart}
                            limitOrderToApprovedStocklist={this.props.limitOrderToApprovedStocklist}
                            limitOrderToTemplateStocklist={this.props.limitOrderToTemplateStocklist}
                            showFullStockInfo={this.props.showFullStockInfo}
                        /></div>;
                    })}
                    </div>
                </div>
        );
    }
}
        
export default withCart(ProductListingGrid);